<template>
  <div class="pkg-class">
    <img src="/images/goods/pkg5.jpg" alt="">
    <div class="item" v-if="albumList[0]" @click="handler(albumList[0])">
      <img :src="albumList[0].picture" alt="">
      <div class="text">
        <h3>{{albumList[0].name}}</h3>
        <p>{{albumList[0].subtitle}}</p>
      </div>
    </div>
    <img src="/images/goods/pkg6.jpg" alt="">
    <div class="item" v-if="albumList[1]" @click="handler(albumList[1])">
      <img :src="albumList[1].picture" alt="">
      <div class="text">
        <h3>{{albumList[1].name}}</h3>
        <p>{{albumList[1].subtitle}}</p>
      </div>
    </div>
    <img src="/images/goods/pkg7.jpg" alt="">
    <div class="item" v-if="albumList[2]" @click="handler(albumList[2])">
      <img :src="albumList[2].picture" alt="">
      <div class="text">
        <h3>{{albumList[2].name}}</h3>
        <p>{{albumList[2].subtitle}}</p>
      </div>
    </div>
    <img src="/images/goods/pkg8.jpg" alt="">
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["albumList"],
  methods: {
    handler(album) {
      if (this.isNative) {
        this.$store.dispatch("externalInterface/navigateTo", {
          name: "album",
          params: {
            id: album.albumId
          }
        });
      } else {
        this.$router.push(`/goods/detail/${album.albumId}`);
      }
    }
  },
  computed: {
    ...mapGetters({
      isNative: "externalInterface/isNative",
    })
  }
};
</script>

<style scoped>
.pkg-class {
  background: #FFF;
}
.pkg-class > img {
  display: block;
  width: 100vw;
}
.item {
  display: flex;
  width: 328px;
  padding: 14px 9px 12px 8px;
  margin: 0 auto;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  position: relative;
}
.item > img {
  display: block;
  width: 94px;
  height: 94px;
  border-radius: 12px;
}
.item .text {
  margin-left: 15px;
  width: 202px;
}
.item h3 {
  font-size: 16px;
  line-height: 22px;
  color: rgba(35, 35, 35, 1);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.item p {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  font-size: 12px;
  color: #244352;
  line-height: 18px;
  word-break: break-all;
}
</style>